export const blockIconsAndroidBattery0BarNew = (
	<span className='material-symbols-outlined'>battery_0_bar</span>
);
